import { createApp } from 'vue';
import { router } from './router';
import { createPinia } from 'pinia';

import App from './App.vue';

// import 'primevue/resources/themes/saga-blue/theme.css';
import PrimeVue from 'primevue/config';

// import 'primevue/resources/themes/lara-light-blue/theme.css';
import 'primevue/resources/themes/mira/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

import '/node_modules/primeflex/primeflex.css';


// https://www.primefaces.org/primevue
// ---------------------------------------------------

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';

import Toolbar from 'primevue/toolbar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import FileUpload from 'primevue/fileupload';
import ProgressSpinner from 'primevue/progressspinner';
import MultiSelect from 'primevue/multiselect';
import Dropdown from 'primevue/dropdown';
import Chip from 'primevue/chip';
import TriStateCheckbox from 'primevue/tristatecheckbox';

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

import Inplace from 'primevue/inplace';
import ScrollTop from 'primevue/scrolltop';
import Toast from 'primevue/toast';

import Ripple from 'primevue/ripple';
import StyleClass from 'primevue/styleclass';
import ToastService from 'primevue/toastservice';

import Tooltip from 'primevue/tooltip';

import { useAppStore } from './stores/app';
// import { useUserStore } from './stores/user';
// import { UserState } from './stores/user.interface';

// ===============================================

const pinia = createPinia();
const app = createApp(App);


app.use(pinia);
app.use(router);
app.use(PrimeVue, { ripple: true });
app.use(ToastService);

// Register PrimeVue components
app.component('Button', Button);
app.component('InputText', InputText);
app.component('Textarea', Textarea);

app.component('Dialog', Dialog);
app.component('Divider', Divider);

app.component('Toolbar', Toolbar);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('FileUpload', FileUpload);
app.component('ProgressSpinner', ProgressSpinner);
app.component('MultiSelect', MultiSelect);
app.component('Dropdown', Dropdown);
app.component('Chip', Chip);
app.component('TriStateCheckbox', TriStateCheckbox);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Inplace', Inplace);
app.component('ScrollTop', ScrollTop);
app.component('Toast', Toast);

app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass);
app.directive('tooltip', Tooltip);

(async () => {
  const appStore = useAppStore();
  // const userStore = useUserStore();

  await router.isReady();

  try {
    // const courseDataResponse = await fetch('course-data.json');
    // appStore.courseData = await courseDataResponse.json();

    await appStore.init();

    app.mount('#app');
  } catch (error) {
    console.error('error getting course data:', error);
  }

})();
